import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M18.6047 26.824C23.6243 26.4904 27.6227 22.4353 27.9518 17.3445C28.0161 16.3483 28.0161 15.0054 27.9518 14.0092C27.6227 8.91839 23.6243 4.86329 18.6047 4.52962C16.8922 4.41579 15.1043 4.41603 13.3953 4.52962C8.37567 4.86329 4.37729 8.91839 4.04829 14.0092C3.98391 15.0054 3.98391 16.3483 4.04829 17.3445C4.16812 19.1986 4.98811 20.9154 5.95349 22.365C6.51401 23.3798 6.14409 24.6464 5.56025 25.7528C5.13929 26.5506 4.92881 26.9494 5.0978 27.2376C5.26681 27.5257 5.64431 27.5349 6.39931 27.5533C7.8924 27.5896 8.89921 27.1663 9.69841 26.577C10.1517 26.2428 10.3783 26.0756 10.5345 26.0564C10.6907 26.0372 10.9981 26.1638 11.6128 26.417C12.1653 26.6445 12.8067 26.7849 13.3953 26.824C15.1043 26.9377 16.8922 26.9379 18.6047 26.824Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse 73",
			cx: 16.0003,
			cy: 15.9998,
			r: 1.33333,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse 74",
			cx: 10.6663,
			cy: 15.9998,
			r: 1.33333,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse 75",
			cx: 21.3333,
			cy: 15.9998,
			r: 1.33333,
			fill: "currentColor"
		})
	]
});
export default SvgMessage;
